import React, { useEffect, useState } from 'react';
import { IonContent, IonPage, IonLoading, IonButton } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import {
  APPOINTMENT_ROUTE,
  COVID_APPOINTMENT_ROUTE
} from '../navigators/AppStackNavigator';
import AccountHeader from '../components/AccountHeader';
import AppHeader from '../components/AppHeader';
import LaboratoryRepository from '../repositories/LaboratoryRepository';
import { Specialty } from '../models/Laboratory';

const SpecialtiesDispatch: React.FC<
  RouteComponentProps<{ laboratoryGroupSlug: string }>
> = ({ match }) => {
  const [specialties, setSpecialties] = useState<Specialty[]>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getSpecialties() {
      setIsLoading(true);
      setSpecialties(
        await LaboratoryRepository.getSpecialties().finally(() => {
          setIsLoading(false);
        })
      );
    }

    getSpecialties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <IonLoading isOpen={isLoading} />
      <AppHeader />
      <IonContent class="ion-padding">
        <div className="wrapper wrapper--medium wrapper--stretch wrapper--centered-md">
          <div className="ion-hide-lg-up">
            <AccountHeader />
          </div>
          <div className="home-card">
            <header className="home-card__header ion-margin-bottom">
              <div className="home-card__header__title ion-margin-bottom">
                <h1>Bienvenue sur</h1>
                <img
                  src={require('../assets/images/logo-unilabs-le-pass.svg')}
                  alt="Le Pass"
                />
              </div>
              <p className="home-card__intro">
                Préparez votre venue en laboratoire.
              </p>
            </header>
            <div className="home-card__buttons">
              {specialties?.map((specialty, i) => (
                <div
                  key={specialty.id}
                  className={
                    i <
                    specialties.length - (specialties.length % 2 === 0 ? 2 : 1)
                      ? 'ion-margin-bottom'
                      : ''
                  }
                >
                  <IonButton
                    routerLink={
                      specialty.id === 'covid'
                        ? `${COVID_APPOINTMENT_ROUTE}`
                        : `${APPOINTMENT_ROUTE}/laboratoire?specialite=${specialty.id}`
                    }
                    expand="block"
                    size="large"
                    color="primary"
                    class="large"
                    routerDirection="forward"
                    onClick={() => {}}
                  >
                    <div className="home-card__inner-button home-card__inner-button--center">
                      <span>{specialty.name}</span>
                    </div>
                  </IonButton>
                </div>
              ))}
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default SpecialtiesDispatch;
